/*
----------------------------
Module - form-embed
----------------------------
*/

import $ from 'jquery';
/*global fmg*/
/*global form_dependent_group_module*/

(function(){
    
    'use strict';

    fmg.formEmbed = function () {

        // Function display success / fail feedback message
        // Note: Default arg for $form_errors is an empty jquery object
        function displayFormFeedback($form_embed, state, $matrix_form_server_error = $()) {

            var $feedback = $form_embed.find("[data-feedback-type='" + state + "']");
            var $dialog;
            var is_close_on_bg_click;

            // Find the correct feedback to show
            if ($feedback.length) {

                // Is this a dialog feedback?
                $dialog = $feedback.closest(".dialog");

                if ($dialog.length) {

                    is_close_on_bg_click = $dialog[0].hasAttribute("data-close-on-bg-click");

                    // Display feedback in a modal dialog
                    $.magnificPopup.open({

                        items: {
                            src: $dialog
                        },
                        type: "inline",
                        showCloseBtn: false,
                        enableEscapeKey: is_close_on_bg_click, 
                        closeOnBgClick: is_close_on_bg_click
                        
                    });

                } else {

                    // Scroll to top of feedback message
                    $("html,body").animate({
                        scrollTop: $feedback.offset().top - 120
                    });
                    
                }

            }
               
        }

        function formSuccessCallback($form_embed) {

            var successCallBackFunctionName = $form_embed.data("success-callback");

            if (typeof window[successCallBackFunctionName] === "function") {

                // try/catch because of potential user input errors in custom success callback code in  Form Success Callback metadata field of form embed ct
                try {
                    window[successCallBackFunctionName]();
                }  catch (e) {
                    console.error("Issue with the code in the Form Success Callback metadata field of the Form Embed CT");
                    console.error(e);
                }
                
            }

        }

        function setupFormEmbedSubmission($form) {

            // Attach custom submit handler to run after jquery validate is successful
            $form.data("validator").settings.submitHandler = function (form) { 
        
                var $form = $(form);

                var $form_embed = $form.closest(".form-embed");

                var action_url = $form.prop("action");

                var formData = new FormData($form[0]);

                // Disable submit button(s) - (Can include previous page button as well)
                var $submit_buttons = $form.find(".sq-form-submit");
                $submit_buttons.prop("disabled", true);

                // Get the submit button (the one that goes forward)
                var $submit_button = $submit_buttons.filter("[id$='_submit']");
                var $fake_submit_button = $('<button type="button" class="btn btn--state-loading disabled">Submitting Form</a>');

                // Hide the real submit button add the fake loading button before the real submit button
                $submit_button.hide().after($fake_submit_button);
                
                // Google recaptcha v3 generates a token to determine if user is not a bot
                // Note that token needs to reach the matrix server to determine this
                grecaptcha.ready(function() {

                    // This long string is the user's site key
                    grecaptcha.execute('6LfVruwaAAAAAIQ8S1KiqoqZ8Cr1bUrWRDk2vZLw', {action: 'formSubmit'}).then(function(token) {
                        
                        formData.append("g-recaptcha-response", token);

                        // Ajax submit the form data
                        $.ajax({

                            url: action_url,
                            data: formData,
                            cache: false,
                            contentType: false,
                            processData: false,
                            method: 'POST',
                            success: function(response){
                                
                                var $response = $(response);
                                
                                // If no form tag in response, its a success page
                                if (!$response.is("form")) {

                                    // Add success form submitted class
                                    $form_embed.addClass("form-embed--submitted");

                                    // Show the real submit button
                                    $submit_button.show();

                                    // Get rid of the fake loading state button
                                    $fake_submit_button.remove();

                                    // Display Success Form Feedback either as a dialog or replace the form
                                    displayFormFeedback($form_embed, "success");

                                    // Run custom success callback (If set)
                                    formSuccessCallback($form_embed);

                                } else {

                                    // If there were form errors in the response (e.g. fail recaptcha), display form error feedback and append form errors
                                    var $matrix_form_server_error = $response.find(".sq-form-error");

                                    if (!$matrix_form_server_error.length) {
                                        
                                        // Need to reinitialise new form setup (inc form dependent, validation) and submission handler

                                        // First remove all existing instances of flatpickr calendar
                                        // Get datepickers
                                        var $date_pickers = $form.find(".flatpickr-input");

                                        // Clear Flatpickr Datepickers
                                        if ($date_pickers.length) {
                                            
                                            $date_pickers.each(function(){
                                                
                                                if(typeof  $(this)[0]._flatpickr !== "undefined"){
                                                    $(this)[0]._flatpickr.destroy();    
                                                }
                                                
                                            });
                                            
                                        }

                                        // Replace existing form with new form
                                        $form.replaceWith($response);

                                        // Set up form dependency again
                                        form_dependent_group_module.init();

                                        // Set up this form
                                        fmg.addAriaLiveAttribute($form_embed);
                                        fmg.addAsteriskToLabels($form_embed);
                                        fmg.setupTextFields($form_embed);
                                        fmg.setupSelectFields($form_embed);
                                        fmg.setupDatetimeFields($form_embed);
                                        fmg.setupMonthPickerFields($form_embed);
                                        fmg.setupFileInputs($form_embed);
                                        fmg.setupAddressFields($form_embed);
                                        
                                        // Validation
                                        fmg.formValidation($form_embed);
                                        fmg.formValidationCustomRules($form_embed);

                                        // Set up submission handler
                                        setupFormEmbedSubmission($response);

                                        // Scroll to top of form only if there were no form errors
                                        $("html,body").animate({
                                            scrollTop: $form_embed.offset().top - 120
                                        });

                                    } else {

                                        // There were matrix server errors

                                        // Re-enable submit buttons
                                        $submit_buttons.prop("disabled", false);

                                        // Show the real submit button
                                        $submit_button.show();

                                        // Get rid of the fake loading state button
                                        $fake_submit_button.remove();

                                        // Don't just replace the current form with the server response
                                        // Use the existing form
                                        displayFormFeedback($form_embed, "blocked");
                                        
                                    }

                                }

                            }

                        }).fail(function() {

                            // Re-enable submit buttons
                            $submit_buttons.prop("disabled", false);

                            // Show the real submit button
                            $submit_button.show();

                            // Get rid of the fake loading state button
                            $fake_submit_button.remove();

                            // If user presses previous page button but somehow it fails to go back, make those fields that used to be required required again
                            $('[data-was-required]').removeAttr("data-was-required").attr("required", "");

                            displayFormFeedback($form_embed, "error");

                        });


                    });

                });

            };

        }

        function overridePrevPagebutton() {

            $("body").on("click", "input[name$='_previous_page']", function() {
                
                // Allow user to go back while also saving the currently selected details
                $('[required]').removeAttr("required").attr("data-was-required", "");
                
            });
    
        }

        function init() {

            $embedded_forms = $(".form-embed form");

            if ($embedded_forms.length) {

                $embedded_forms.each(function() {

                    var $this_embedded_form = $(this);

                    overridePrevPagebutton();

                    setupFormEmbedSubmission($this_embedded_form);

                });
                
            }

        }

        var $embedded_forms;
        
        return {
            init: init,
        };

    }();
    
}());
